import { Field } from "formik";
import { memo } from "react";
import "./index.scss";

interface InputProps {
  name: string;
  label?: string;
  placeholder: string;
  type: string;
  value: any;
  onBlur?: any;
  onChange: any;
  required?: boolean;
  className?: string;
  disabled?: boolean;
  errorMessage?: string;
  errorStatus?: boolean;
  minlength?: string;
  maxlength?: string;
  max?: string;
  min?: string;
  porcentage?: boolean;
  autofocus?: boolean;
  list?: string
}

function InputFormik({
  name,
  label,
  placeholder,
  type,
  required,
  value,
  onBlur,
  onChange,
  className,
  disabled,
  errorStatus,
  errorMessage,
  minlength,
  maxlength,
  max,
  min,
  porcentage,
  autofocus,
  list
}: InputProps) {
  return (
    <div className={`form-input ${className} ${errorStatus && "invalid"}`}>
      {label && <label>{label}{required?<span className="text-red"> *</span>: ""}</label>}
      <Field
        className={`input ${className} ${disabled ? "disabled-input" : ""}`}
        placeholder={placeholder}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        disabled={disabled || false}
        required={required || false}
        type={type || "text"}
        minlength={minlength}
        maxlength={maxlength}
        max={max}
        min={min}
        porcentage={porcentage}
        autoFocus={autofocus}
        list={list}
      />
      {porcentage && <i>%</i>}
      {errorStatus && <span className={`errorStatus`}>{errorMessage}</span>}
    </div>
  );
}

export default memo(InputFormik);
